/* eslint-disable react/forbid-prop-types */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {compose, withApollo} from 'react-apollo';
import {IntlProvider} from 'react-intl';
import {debounce} from 'lodash';
import {EdapProvider} from '@homeaway/react-event-tracking';
import MultiUnitDropdown from './MultiUnitDropdown/MultiUnitDropdown';
import MultiUnitModal from './MultiUnitModal/MultiUnitModal';
import './MultiUnitHit.less';

class MultiUnitHit extends Component {
    render() {
        const {
            onMouseEnter,
            onMouseLeave,
            listing,
            inputParams,
            currency,
            isMetric,
            isDesktop,
            isDatelessSearch,
            clientLogger,
            lingua
        } = this.props;
        const propertyName =
            (listing && listing.propertyMetadata && listing.propertyMetadata.propertyName) ||
            listing.propertyType ||
            '';
        const handleMouseEnter = () =>
            listing && onMouseEnter ? onMouseEnter(listing.listingId) : null;
        const handleMouseLeave = () =>
            listing && onMouseLeave ? onMouseLeave(listing.listingId) : null;
        const onMouseTimeout = 100;
        const defaultOptions = {delayProcessing: false};

        const multiUnitListing = isDesktop ? (
            <MultiUnitDropdown
                inputParams={inputParams}
                listing={listing}
                propertyName={propertyName}
                currency={currency}
                isMetric={isMetric}
                isDatelessSearch={isDatelessSearch}
                showDesktopView={isDesktop}
                clientLogger={clientLogger}
            />
        ) : (
            <MultiUnitModal
                inputParams={inputParams}
                listing={listing}
                propertyName={propertyName}
                currency={currency}
                isMetric={isMetric}
                isDatelessSearch={isDatelessSearch}
                showDesktopView={isDesktop}
                clientLogger={clientLogger}
            />
        );

        return (
            <EdapProvider options={defaultOptions}>
                <IntlProvider locale={lingua.locale} key={lingua.key} messages={lingua.messages}>
                    <div
                        className="MultiUnitHit"
                        role="presentation"
                        onMouseEnter={debounce(handleMouseEnter, onMouseTimeout)}
                        onMouseLeave={debounce(handleMouseLeave, onMouseTimeout)}
                    >
                        <div className="MultiUnitHit__header">
                            <div className="MultiUnitHit__header-column MultiUnitHit__header-column--left">
                                <span className="MultiUnitHit__header-text truncated-span">
                                    <strong>{propertyName}</strong>
                                </span>
                            </div>
                            {multiUnitListing}
                        </div>
                        {this.props.children}
                    </div>
                </IntlProvider>
            </EdapProvider>
        );
    }
}

MultiUnitHit.propTypes = {
    /** Object of listing data used to obtain related hits and render heading. */
    listing: PropTypes.object,
    /** Object of search parameters data used in GTS calls to obtain related hits. */
    inputParams: PropTypes.object,
    /** Prop to define whether component should be rendered on desktop as dropdown */
    isDesktop: PropTypes.bool,
    /** Prop to define currency arg for priceSummary query */
    currency: PropTypes.string,
    /** Prop to switch between metric and imperial system labels  */
    isMetric: PropTypes.bool,
    /** Prop to check whether component should display average price value */
    isDatelessSearch: PropTypes.bool,
    /** Object of callbacks used to log message and exceptions occured during component constructions. */
    clientLogger: PropTypes.objectOf(PropTypes.func),
    /** Object of lingua locale, key and messges passed to IntlProvider. */
    lingua: PropTypes.object,
    /** Function called with listingId on mouse pointer entered MU wrapped hit. */
    onMouseEnter: PropTypes.func,
    /** Function called with listingId on mouse pointer left MU wrapped hit. */
    onMouseLeave: PropTypes.func
};

export default compose(withApollo)(MultiUnitHit);
